import { useEffect, use, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { GetContractsForCampaign } from 'services'
import { CampaignUpdatedEvent, NotificationType } from 'types/pushNotifications'
import { NotificationContext } from 'contexts'
import { Contract } from 'types/campaigns'
import { AuthContext } from '@urbanx/agx.auth.client'

const useContractsList = (): {
  contracts: Contract[]
  isLoading: boolean
} => {
  const { campaignId } = useParams()
  const queryClient = useQueryClient()
  const { getAuthToken } = useContext(AuthContext)
  const notifications = use(NotificationContext)
  const contractsQueryKey = ['all-contracts', campaignId]

  const campaignUpdated = async (event: CampaignUpdatedEvent) => {
    if (event.campaignId === campaignId) {
      await queryClient.invalidateQueries({ queryKey: contractsQueryKey })
    }
  }

  useEffect(() => {
    if (!campaignId) return

    notifications?.registerEvent(
      NotificationType.CampaignUpdatedEvent,
      campaignUpdated,
      contractsQueryKey
    )
  }, [contractsQueryKey])

  const { data: contracts, isLoading } = useQuery<Contract[] | undefined>({
    queryKey: contractsQueryKey,
    queryFn: () => {
      return GetContractsForCampaign(getAuthToken, campaignId)
    },
    enabled: !!campaignId,
  })

  return {
    contracts: contracts ?? [],
    isLoading,
  }
}

export default useContractsList
